/* =========================================================
   Cart Drawer — Side-Panel, AJAX-Warenkorb, Toast, Upsell
   Vanilla JS, keine Abhängigkeiten.
   ========================================================= */
(function () {
  'use strict';

  var drawer = document.querySelector('[data-cart-drawer]');
  var overlay = document.querySelector('[data-cd-overlay]');
  if (!drawer || !overlay) return;

  var body = drawer.querySelector('[data-cd-body]');
  var footSubtotal = drawer.querySelector('[data-cd-subtotal]');
  var countEls = document.querySelectorAll('[data-cd-count]');
  var headerCartCount = document.querySelector('.cart-count');
  var upsellWrap = drawer.querySelector('[data-cd-upsell-wrap]');
  var upsellRow = drawer.querySelector('[data-cd-upsell-row]');
  var shipWrap = drawer.querySelector('[data-cd-shipbar]');
  var shipText = drawer.querySelector('[data-cd-shipbar-text]');
  var shipFill = drawer.querySelector('[data-cd-shipbar-fill]');

  var cfg = (window.CartDrawerConfig || {});
  var moneyFormat = cfg.moneyFormat || '€{{amount}}';
  var freeShipThreshold = parseInt(cfg.freeShipThreshold || '0', 10); // in Cent, 0 = aus

  /* ---------- Money ---------- */
  function formatMoney(cents) {
    cents = parseInt(cents || 0, 10);
    function withComma() {
      return (cents / 100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    }
    function withDot() {
      return (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
    var out = moneyFormat;
    out = out.replace(/\{\{\s*amount\s*\}\}/g, withComma());
    out = out.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withComma());
    out = out.replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(cents / 100).toString());
    out = out.replace(/\{\{\s*amount_with_space_separator\s*\}\}/g, withComma());
    out = out.replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/g, withComma());
    if (out === moneyFormat) out = '€' + withComma();
    return out;
  }

  /* ---------- Upsell-Daten ---------- */
  var upsellData = [];
  try {
    var raw = document.querySelector('[data-cd-upsell-data]');
    if (raw) upsellData = JSON.parse(raw.textContent.trim() || '[]');
  } catch (e) { upsellData = []; }

  /* ---------- Drawer öffnen/schließen ---------- */
  function openDrawer() {
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cd-is-open');
    refresh(); // immer aktuellen Stand laden
  }
  function closeDrawer() {
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cd-is-open');
  }
  window.openCartDrawer = openDrawer;
  window.closeCartDrawer = closeDrawer;

  overlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
  });
  drawer.addEventListener('click', function (e) {
    var c = e.target.closest('[data-cd-close]');
    if (c) { e.preventDefault(); closeDrawer(); }
  });

  /* ---------- Cart-Icon im Header -> Drawer ---------- */
  var headerCartLink = document.querySelector('.site-header__actions a[href$="/cart"], .site-header__actions a[href*="/cart"]');
  if (headerCartLink) {
    headerCartLink.addEventListener('click', function (e) {
      e.preventDefault();
      openDrawer();
    });
  }

  /* ---------- Zeilen-Markup ----------
     BUNDLE-BADGE-LOGIK (muss mit cart-drawer-items.liquid übereinstimmen!):
     - cartQty == 2  ->  Badge "2er BUNDLE" auf reduzierter Brille
     - cartQty >= 3  ->  Badge "3er BUNDLE" auf allen reduzierten Brillen
     Reduzierung: item.original_line_price > item.final_line_price
  */
  function renderLine(item, cartQty) {
    var img = item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') : '';
    var variant = '';
    if (item.variant_title && item.variant_title.indexOf('Default') === -1) {
      variant = '<div class="cd-line__variant">' + escapeHtml(item.variant_title) + '</div>';
    }

    var origPrice = parseInt(item.original_line_price || 0, 10);
    var finalPrice = parseInt(item.final_line_price || 0, 10);
    var isReduced = origPrice > finalPrice;

    var bundleBadge = '';
    if (isReduced && cartQty >= 2) {
      var label = cartQty >= 3 ? '3er BUNDLE' : '2er BUNDLE';
      bundleBadge =
        '<span class="cd-line__bundle-badge">' +
          '<svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
            '<path d="M20 12v10H4V12"/><path d="M2 7h20v5H2z"/><path d="M12 22V7"/>' +
            '<path d="M12 7H7.5a2.5 2.5 0 010-5C11 2 12 7 12 7z"/>' +
            '<path d="M12 7h4.5a2.5 2.5 0 000-5C13 2 12 7 12 7z"/>' +
          '</svg>' +
          label +
        '</span>';
    }

    var priceHtml;
    if (isReduced) {
      priceHtml =
        '<span class="cd-line__price-old">' + formatMoney(origPrice) + '</span>' +
        '<span class="cd-line__price-new">' + formatMoney(finalPrice) + '</span>';
    } else {
      priceHtml = formatMoney(finalPrice);
    }

    return '' +
      '<div class="cd-line' + (isReduced ? ' cd-line--reduced' : '') + '" data-cd-line data-key="' + item.key + '">' +
        '<a href="' + item.url + '" class="cd-line__img">' +
          (img ? '<img src="' + img + '" alt="' + escapeHtml(item.product_title) + '" loading="lazy">' : '') +
        '</a>' +
        '<div class="cd-line__main">' +
          bundleBadge +
          '<a href="' + item.url + '" class="cd-line__title">' + escapeHtml(item.product_title) + '</a>' +
          variant +
          '<div class="cd-line__bottom">' +
            '<div class="cd-qty" data-cd-qty>' +
              '<button type="button" data-cd-minus aria-label="Weniger">−</button>' +
              '<span data-cd-qty-val>' + item.quantity + '</span>' +
              '<button type="button" data-cd-plus aria-label="Mehr">+</button>' +
            '</div>' +
            '<button type="button" class="cd-line__remove" data-cd-remove>Entfernen</button>' +
          '</div>' +
        '</div>' +
        '<div class="cd-line__price">' + priceHtml + '</div>' +
      '</div>';
  }

  function renderEmpty() {
    return '' +
      '<div class="cd-empty" data-cd-empty>' +
        '<h3>Dein Warenkorb ist leer</h3>' +
        '<p>Entdecke unsere Brillen.</p>' +
        '<a href="/collections/all" class="btn btn--primary" data-cd-close>Jetzt shoppen</a>' +
      '</div>';
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  /* ---------- Render gesamtes Cart ---------- */
  function renderCart(cart) {
    if (!cart) return;

    if (cart.item_count > 0) {
      var totalQty = cart.item_count;
      body.innerHTML = cart.items.map(function (it) { return renderLine(it, totalQty); }).join('');
    } else {
      body.innerHTML = renderEmpty();
    }

    if (footSubtotal) footSubtotal.textContent = formatMoney(cart.total_price);
    countEls.forEach(function (el) { el.textContent = cart.item_count; });

    // Header-Badge aktualisieren
    updateHeaderCount(cart.item_count);

    // Versand-Fortschritt
    renderShipbar(cart.total_price);

    // Upsell
    renderUpsell(cart);
  }

  var lastKnownCount = null;
  function updateHeaderCount(count) {
    headerCartCount = document.querySelector('.cart-count');
    var wrap = document.querySelector('.site-header__actions a');
    var shouldBump = lastKnownCount !== null && count > lastKnownCount;
    if (count > 0) {
      if (!headerCartCount && wrap) {
        headerCartCount = document.createElement('span');
        headerCartCount.className = 'cart-count';
        wrap.appendChild(headerCartCount);
      }
      if (headerCartCount) {
        headerCartCount.textContent = count;
        if (shouldBump) {
          headerCartCount.classList.remove('cd-bump');
          void headerCartCount.offsetWidth;
          headerCartCount.classList.add('cd-bump');
        }
      }
    } else if (headerCartCount) {
      headerCartCount.remove();
    }
    lastKnownCount = count;
  }

  function renderShipbar(total) {
    if (!shipWrap || freeShipThreshold <= 0) { if (shipWrap) shipWrap.style.display = 'none'; return; }
    shipWrap.style.display = 'block';
    if (total >= freeShipThreshold) {
      shipText.innerHTML = '🎉 <b>Versandkostenfrei!</b> Du hast den kostenlosen Versand freigeschaltet.';
      shipFill.style.width = '100%';
    } else {
      var remain = freeShipThreshold - total;
      shipText.innerHTML = 'Nur noch <b>' + formatMoney(remain) + '</b> bis zum kostenlosen Versand!';
      shipFill.style.width = Math.min(100, (total / freeShipThreshold) * 100) + '%';
    }
  }

  /* ---------- Upsell-Leiste ---------- */
  var upsellAutoTimer = null;
  var upsellResumeTimer = null;

  function stopUpsellAuto() {
    if (upsellAutoTimer) { clearInterval(upsellAutoTimer); upsellAutoTimer = null; }
  }

  function startUpsellAuto() {
    stopUpsellAuto();
    if (!upsellRow) return;
    var cards = upsellRow.querySelectorAll('[data-cd-upsell-card]');
    if (cards.length < 2) return; // bei 1 Produkt kein Wechsel nötig
    upsellAutoTimer = setInterval(function () {
      if (!drawer.classList.contains('is-open')) return; // nur bei offenem Drawer
      var w = upsellRow.clientWidth;
      if (w <= 0) return;
      var idx = Math.round(upsellRow.scrollLeft / w);
      var next = idx + 1;
      if (next >= cards.length) next = 0;
      upsellRow.scrollTo({ left: next * w, behavior: 'smooth' });
      updateUpsellDots(next);
    }, 4000);
  }

  function pauseThenResumeUpsellAuto() {
    stopUpsellAuto();
    if (upsellResumeTimer) clearTimeout(upsellResumeTimer);
    upsellResumeTimer = setTimeout(startUpsellAuto, 6000);
  }

  function updateUpsellDots(activeIdx) {
    if (!upsellWrap) return;
    var dots = upsellWrap.querySelectorAll('[data-cd-dot]');
    dots.forEach(function (d, i) { d.classList.toggle('is-active', i === activeIdx); });
  }

  function renderUpsell(cart) {
    if (!upsellWrap || !upsellRow || !upsellData.length) {
      if (upsellWrap) upsellWrap.style.display = 'none';
      stopUpsellAuto();
      return;
    }
    var inCart = {};
    (cart.items || []).forEach(function (it) { inCart[it.variant_id] = true; });

    var items = upsellData.filter(function (p) {
      return p.available && !inCart[p.id];
    });

    if (!items.length) { upsellWrap.style.display = 'none'; stopUpsellAuto(); return; }

    upsellWrap.style.display = 'block';
    upsellRow.innerHTML = items.map(function (p) {
      return '' +
        '<div class="cd-upsell-card" data-cd-upsell-card>' +
          '<a href="' + p.url + '" class="cd-upsell-card__img">' +
            (p.image ? '<img src="' + p.image + '" alt="' + escapeHtml(p.title) + '" loading="lazy">' : '') +
          '</a>' +
          '<div class="cd-upsell-card__info">' +
            '<a href="' + p.url + '" class="cd-upsell-card__title">' + escapeHtml(p.title) + '</a>' +
            '<div class="cd-upsell-card__price">' + (p.price_formatted || formatMoney(p.price)) + '</div>' +
          '</div>' +
          '<button type="button" class="cd-upsell-card__add" data-cd-upsell-add data-id="' + p.id + '">+ Hinzufügen</button>' +
        '</div>';
    }).join('');

    // Punkt-Indikatoren
    var dotsWrap = upsellWrap.querySelector('[data-cd-dots]');
    if (dotsWrap) {
      if (items.length > 1) {
        dotsWrap.innerHTML = items.map(function (_, i) {
          return '<span class="cd-upsell-dot' + (i === 0 ? ' is-active' : '') + '" data-cd-dot></span>';
        }).join('');
        dotsWrap.style.display = 'flex';
      } else {
        dotsWrap.innerHTML = '';
        dotsWrap.style.display = 'none';
      }
    }

    upsellRow.scrollLeft = 0;
    startUpsellAuto();
  }

  /* ---------- Cart laden ---------- */
  function fetchCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }
  function refresh() {
    return fetchCart().then(renderCart).catch(function (e) { console.error(e); });
  }

  /* ---------- Menge ändern / entfernen ---------- */
  function changeLine(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }

  body.addEventListener('click', function (e) {
    var line = e.target.closest('[data-cd-line]');
    if (!line) return;
    var key = line.getAttribute('data-key');
    var valEl = line.querySelector('[data-cd-qty-val]');
    var current = parseInt(valEl ? valEl.textContent : '1', 10);

    if (e.target.closest('[data-cd-plus]')) {
      changeLine(key, current + 1);
    } else if (e.target.closest('[data-cd-minus]')) {
      changeLine(key, Math.max(0, current - 1));
    } else if (e.target.closest('[data-cd-remove]')) {
      changeLine(key, 0);
    }
  });

  /* ---------- Upsell hinzufügen ---------- */
  upsellRow && upsellRow.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cd-upsell-add]');
    if (!btn) return;
    var id = btn.getAttribute('data-id');
    btn.disabled = true;
    var orig = btn.textContent;
    addToCart(id, 1).then(function () {
      btn.classList.add('is-added');
      btn.textContent = 'Hinzugefügt ✓';
      return refresh();
    }).catch(function () {
      btn.disabled = false;
      btn.textContent = orig;
    });
  });

  /* ---------- Manuelles Swipen: Auto-Wechsel pausieren + Dots live updaten ---------- */
  if (upsellRow) {
    var scrollDebounce = null;
    upsellRow.addEventListener('scroll', function () {
      var w = upsellRow.clientWidth;
      if (w > 0) updateUpsellDots(Math.round(upsellRow.scrollLeft / w));
      if (scrollDebounce) clearTimeout(scrollDebounce);
      scrollDebounce = setTimeout(function () {
        // nach Scroll-Ende kurz pausieren, dann wieder aufnehmen
        pauseThenResumeUpsellAuto();
      }, 150);
    }, { passive: true });

    ['touchstart', 'pointerdown', 'mouseenter'].forEach(function (ev) {
      upsellRow.addEventListener(ev, stopUpsellAuto, { passive: true });
    });
    ['touchend', 'touchcancel', 'pointerup', 'pointercancel', 'mouseleave'].forEach(function (ev) {
      upsellRow.addEventListener(ev, pauseThenResumeUpsellAuto, { passive: true });
    });
  }

  /* ---------- Zentrale Add-to-Cart-Funktion ----------
     Nutzt den Shopify-Standard-Endpoint /cart/add.js und meldet jeden
     erfolgreichen Add per "cart:added"-CustomEvent (mit den ECHTEN
     Items aus der Shopify-Antwort: variant_id, Preis, Menge) — u. a.
     fürs TikTok-Pixel-Tracking. */
  function notifyCartAdded(res) {
    try {
      var items = (res && res.items) ? res.items : (res && res.id ? [res] : []);
      document.dispatchEvent(new CustomEvent('cart:added', {
        bubbles: true,
        detail: { items: items }
      }));
    } catch (e) {}
  }
  function addToCart(id, quantity, properties) {
    var payload = { items: [{ id: id, quantity: quantity || 1 }] };
    if (properties) payload.items[0].properties = properties;
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (err) { throw err; });
      return r.json();
    }).then(function (res) {
      notifyCartAdded(res);
      return res;
    });
  }
  function addMultiple(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (err) { throw err; });
      return r.json();
    }).then(function (res) {
      notifyCartAdded(res);
      return res;
    });
  }

  /* ---------- Toast / Popup ---------- */
  var toastEl = null;
  var toastTimer = null;
  function showToast(addResult) {
    // addResult ist die /cart/add.js-Antwort (zuletzt hinzugefügtes Item)
    var item = addResult;
    if (addResult && addResult.items && addResult.items.length) {
      item = addResult.items[addResult.items.length - 1];
    }
    if (!item) return;

    var img = item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2') : '';
    var title = item.product_title || item.title || 'Produkt';

    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'cd-toast';
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = '' +
      '<div class="cd-toast__img">' + (img ? '<img src="' + img + '" alt="">' : '') + '</div>' +
      '<div class="cd-toast__main">' +
        '<div class="cd-toast__badge">' +
          '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg>' +
          'In den Warenkorb gelegt' +
        '</div>' +
        '<div class="cd-toast__title">' + escapeHtml(title) + '</div>' +
      '</div>' +
      '<button type="button" class="cd-toast__view" data-cd-toast-view>Ansehen</button>';

    toastEl.querySelector('[data-cd-toast-view]').addEventListener('click', function () {
      hideToast();
      openDrawer();
    });

    void toastEl.offsetWidth;
    toastEl.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(hideToast, 4000);
  }
  function hideToast() {
    if (toastEl) toastEl.classList.remove('is-visible');
  }

  /* ---------- Produkt-Formular abfangen (bleibt auf Seite) ---------- */
  function interceptProductForm() {
    var form = document.getElementById('product-form');
    if (!form) return;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('#product-cta') || form.querySelector('[type="submit"]');
      var idInput = form.querySelector('[name="id"]');
      if (!idInput) return;

      var origText = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Wird hinzugefügt…'; }

      // optionale Properties aus dem Formular sammeln
      var fd = new FormData(form);
      var properties = {};
      fd.forEach(function (val, name) {
        var m = name.match(/^properties\[(.+)\]$/);
        if (m && val) properties[m[1]] = val;
      });

      var qtyField = form.querySelector('[name="quantity"]');
      var qty = qtyField ? parseInt(qtyField.value || '1', 10) : 1;

      addToCart(idInput.value, qty, Object.keys(properties).length ? properties : null)
        .then(function (res) {
          showToast(res);
          return refresh();
        })
        .then(function () {
          if (btn) {
            btn.textContent = 'Hinzugefügt ✓';
            setTimeout(function () {
              btn.disabled = false;
              btn.textContent = btn.getAttribute('data-default-text') || origText || 'IN DEN WARENKORB LEGEN';
            }, 1400);
          }
        })
        .catch(function (err) {
          console.error(err);
          if (btn) { btn.disabled = false; btn.textContent = origText; }
          alert((err && err.description) || 'Konnte nicht zum Warenkorb hinzugefügt werden.');
        });
    });
  }

  /* ---------- Bundle-Button abfangen (2x Variante, bleibt auf Seite) ---------- */
  function interceptBundle() {
    var bundleBtn = document.querySelector('[data-add-bundle]');
    if (!bundleBtn) return;
    // bestehenden Handler ausschalten, indem wir das Element klonen
    var clone = bundleBtn.cloneNode(true);
    bundleBtn.parentNode.replaceChild(clone, bundleBtn);
    bundleBtn = clone;

    bundleBtn.addEventListener('click', function () {
      if (bundleBtn.disabled) return;
      var form = document.getElementById('product-form');
      var idInput = form && form.querySelector('[name="id"]');
      if (!idInput) return;
      bundleBtn.disabled = true;
      var txt = bundleBtn.querySelector('.product__bundle-cta-text');
      var origTxt = txt ? txt.textContent : '';

      addToCart(idInput.value, 2)
        .then(function (res) {
          bundleBtn.classList.add('is-added');
          if (txt) txt.textContent = 'HINZUGEFÜGT ✓';
          showToast(res);
          return refresh();
        })
        .then(function () {
          setTimeout(function () {
            bundleBtn.disabled = false;
            bundleBtn.classList.remove('is-added');
            if (txt) txt.textContent = origTxt;
          }, 1600);
        })
        .catch(function (e) {
          console.error(e);
          bundleBtn.disabled = false;
        });
    });
  }

  /* ---------- Produkt-Upsell (Zubehör) abfangen ---------- */
  function interceptProductUpsell() {
    var upsellBtn = document.querySelector('[data-add-upsell]');
    if (!upsellBtn) return;
    var clone = upsellBtn.cloneNode(true);
    upsellBtn.parentNode.replaceChild(clone, upsellBtn);
    upsellBtn = clone;

    upsellBtn.addEventListener('click', function () {
      var variantId = upsellBtn.getAttribute('data-variant-id');
      var form = document.getElementById('product-form');
      var mainId = form && form.querySelector('[name="id"]') ? form.querySelector('[name="id"]').value : null;
      if (!variantId) return;
      upsellBtn.disabled = true;
      var orig = upsellBtn.textContent;

      var items = [];
      if (mainId) items.push({ id: mainId, quantity: 1 });
      items.push({ id: variantId, quantity: 1 });

      addMultiple(items)
        .then(function (res) {
          showToast(res);
          return refresh();
        })
        .then(function () {
          upsellBtn.textContent = 'Hinzugefügt ✓';
          setTimeout(function () { upsellBtn.disabled = false; upsellBtn.textContent = orig; }, 1500);
        })
        .catch(function (e) {
          console.error(e);
          upsellBtn.disabled = false;
          upsellBtn.textContent = orig;
        });
    });
  }

  /* ---------- Init ---------- */
  function init() {
    interceptProductForm();
    interceptBundle();
    interceptProductUpsell();
    refresh();
  }

  /* ---------- Theme-weite Cart-Events ----------
     Sections (Bundle, Promohero, Produktseite) feuern diese Events
     nach eigenen /cart/add.js-Aufrufen — Drawer reagiert darauf. */
  document.addEventListener('cart:refresh', function () { refresh(); });
  document.addEventListener('cart:open', function () { openDrawer(); });
  document.addEventListener('cart:added', function () { refresh(); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
